// main.js
import { createApp } from 'vue';
import { createHead } from '@unhead/vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import store from './store';
import ChatComponent from '@/components/ChatComponent.vue';
import globalNavigation from "@/mixins/globalNavigation"

// -------------- NODE_MODULES CSS (preferred) --------------
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// -------------- YOUR PROJECT CSS (keep after vendor CSS) --------------
import './assets/css/vendors/all.min.css';
import './assets/css/temp.css';
import './assets/css/custom.css';
import './assets/css/new_design.css';
import './assets/css/responsive.css';

// -------------- NODE_MODULES JS (preferred) --------------
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// -------------- jQuery (make global for Slick & other scripts) --------------
import $ from 'jquery';
window.$ = window.jQuery = $;

// -------------- Slick from npm (JS) --------------
import 'slick-carousel';

// -------------- Optional: keep other site scripts that depend on jQuery --------------
import './assets/js/scripts.js';
import './assets/menu/script.js';

// Initialize head
const head = createHead();

const app = createApp(App)
  .use(head)
  .use(store)
  .use(router);

app.component('ChatComponent', ChatComponent);
app.mixin(globalNavigation)
app.mount('#app');
